module.exports = __webpack_public_path__ + "assets/img/1-4-bar.ef6c434e.png";